(ns assemble.component.dropzone
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [bean]]
            [uix.core :refer [$ defui]]))

(defui upload-area-placeholder [{:keys [drop-active asset-type modal-view on-open]}]
  (let [{:keys [icon action description header]}
        (case asset-type
          :fonts {:icon "text_fields"
                  :header (if modal-view
                            "Add font files"
                            "Add fonts")
                  :description (if modal-view
                                 "Drag and drop your files anywhere, or"
                                 "Upload fonts to be reused across your campaigns")
                  :action (if modal-view "Browse files" "New font")}

          :logos {:icon "image"
                  :header "Add logo"
                  :description "Drag and drop your files anywhere, or"
                  :action (if modal-view "Browse files" "New logo")}

          :templates {:icon "picture_in_picture"
                      :header "Add template"
                      :description "Drag and drop your file anywhere, or"
                      :action "Browse files"}

          {:icon "drive_folder_upload"
           :header "Add files & folders"
           :description "Drag and drop your files anywhere, or"
           :action "Browse files"})]
    ($ Grid
       {:flex 1
        :container true
        :direction "column"
        :alignItems "center"
        :justifyContent "center"}
       ($ Icon
          {:sx #js {:mb 1
                    :fontSize "6rem"
                    :color "text.secondary"}}
          (if drop-active "cloud_upload" icon))
       ($ Typography {:variant "h4" :component "span"}
          (if drop-active "Drop files to upload" header))
       ($ Typography {:sx #js {:mb 1}}
          (if drop-active "Your files will be ready to review" description))
       ($ Button
          {:variant "outlined"
           :color "primary"
           :data-testid "browseFilesButton"
           :sx #js {:width "30%"
                    :maxWidth "300px"
                    ;; Keep the button in place, but hide it, so that other content
                    ;; doesn't move.
                    :opacity (if drop-active 0 1)}
           :onClick on-open}
          action))))

(defui grid-drop-overlay [{:keys [asset-type]}]
  ($ Grid
     {:sx #js {:position "absolute"
               :top 0
               :bottom 0
               :left 0
               :right 0
               :opacity 0.9
               :display "flex"
               :bgcolor "grey.60"
               :borderColor "primary.main"
               :borderWidth 2
               :borderStyle "dashed"}}
     ($ upload-area-placeholder
        {:drag-active true
         :asset-type asset-type})))

(defn grid-drop-props [^js dropzone]
  (let [drop-props (.getRootProps dropzone)]
    {;; From dropzone props - build new props map manually,
     ;; to use Capture phase for one event.
     :onBlur (.-onBlur drop-props)
     :onClick (.-onClick drop-props)
     ;; Use Capture phase for DragEnter events,
     ;; so that we can see the event even when
     ;; file is hovering the table contents.
     :onDragEnterCapture (.-onDragEnter drop-props)
     :onDragLeave (.-onDragLeave drop-props)
     :onDragOver (.-onDragOver drop-props)
     :onDrop (.-onDrop drop-props)
     :onFocus (.-onFocus drop-props)
     :onKeyDown (.-onKeyDown drop-props)
     :ref (.-ref drop-props)
     :role "presentation"}))

(defui dropzone-container [{:keys [^js dropzone queue asset-type children]}]
  (let [drop-props (.getRootProps dropzone)
        drop-active (.-isDragActive dropzone)]
    ($ Grid
       (merge (grid-drop-props dropzone)
              {;; Disable click if we already have queue
               :onClick (if (seq queue)
                          nil
                          (.-onClick drop-props))
               :flex 1
               :container true
               :sx #js {:position "relative"
                        :borderColor (if drop-active
                                       "primary.main"
                                       "grey.60")
                        :borderWidth (if (seq queue) 0 2)
                        :borderStyle "dashed"
                        :bgcolor (when (and drop-active (not (seq queue)))
                                   "grey.60")}})
       ($ :input (merge (bean (.getInputProps dropzone))
                        {:data-testid "browseFilesInput"}))
       children
       (when (and (seq queue)
                  (.-isDragActive dropzone))
         ($ grid-drop-overlay {:asset-type asset-type})))))
